import { ListarEmpreendimentosController } from "../../../../Controllers/Geral/Produtos/ProdutosControllers";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import CadastraEEditaProduto from "../CadastraEEditaProduto";

export default function CadastrarProduto() {
    const { execute: listarEmpreendimentos } = useAsyncEffect(
        ListarEmpreendimentosController
    );

    return (
        <>
            <CadastraEEditaProduto
                updateList={listarEmpreendimentos}
                editando={false}
            />
        </>
    );
}
